import React, { Component } from "react";
import Stater from "./Stater";
import Staterfarge from "./Staterfarge";

class Caromodal extends Component {
  render() {
    let modalSource = `id${this.props.caroId}-modal`;
    let modalLabel = `id${this.props.caroId}-modal-label`;
    let carouselID = `id${this.props.caroId}-fixid-modal`;
    let carouselFixIDhashModal = `#id${this.props.caroId}-fixid-modal`;

    let numProdsModal = "Not set.";
    let tittelPris = this.props.pris1;
    let linkModal1 = this.props.link1;
    let linkModal2 = this.props.link2;
    let linkModal3 = this.props.link3;

    if (this.props.pris1 && this.props.pris2 === false && this.props.farge === "Messing") {
      numProdsModal = (
        <div>
          {/* <button type="button" className="btn btn-secondary mr-2" data-dismiss="modal">
            Lukk vindu
          </button> */}

          <a href={linkModal1} className="btn btn-success">
            Kjøp nå
          </a>
        </div>
      );
    }

    if (this.props.pris1 && this.props.pris2 === false && this.props.farge === "Svart") {
      numProdsModal = (
        <div>
          <a href={linkModal1} className="btn mb-2 btn-success">
            Kjøp nå
          </a>
        </div>
      );
    }

    if (this.props.pris1 && this.props.pris2 && this.props.pris3 === false) {
      tittelPris = false;
      numProdsModal = <Staterfarge pris1={this.props.pris1} pris2={this.props.pris2} pris3={this.props.pris3} mppid1={linkModal1} mppid2={linkModal2} mppid3={linkModal3} handleChildChange={this.props.handleChildChange} />;
    }
    if (this.props.pris1 && this.props.pris2 && this.props.pris3 /* && this.props.farge === 'Svart' */) {
      tittelPris = false;
      numProdsModal = <Stater pris1={this.props.pris1} pris2={this.props.pris2} pris3={this.props.pris3} mppid1={linkModal1} mppid2={linkModal2} mppid3={linkModal3} handleChildChange={this.props.handleChildChange} />;
    }

    return (
      <div>
        {/* hide on screens smaller than lg*/}
        {/* //<!-- Button trigger modal --> */}
        {/* <a href="" data-toggle="modal" data-target={triggerTarget}>
          Store bilder
        </a> */}
        {/* MODAL */}
        <div className="modal fade" id={modalSource} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title" id="exampleModalLabel">
                  <strong>{this.props.tittel}</strong>
                </div>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {/* MODAL BODY*/}
                <div id={carouselID} className="carousel slide carousel-fade" data-ride="carousel" data-interval="5000">
                  <div className="carousel-inner">
                    <div className="carousel-item active">
                      <img src={this.props.activeCaro} className="d-block w-100" alt="..." />
                    </div>
                    {this.props.imgs.map((p) => (
                      <div key={p.img} className="carousel-item">
                        <img className="d-block w-100" src={p.img} alt={this.props.caroId} />
                      </div>
                    ))}
                  </div>
                  <a className="carousel-control-prev" href={carouselFixIDhashModal} role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a className="carousel-control-next" href={carouselFixIDhashModal} role="button" data-slide="next">
                    <span className="carousel-control-next-icon text-secondary" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>
                  {/* {numProdsModal} */}
                  {/* Bildene er veiledende. */}
                </div>
              </div>

              <div className="modal-footer">
                <h3>{tittelPris}</h3>

                {numProdsModal}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Caromodal;
